<template>
   <footer class="page-footer font-small blue">
    <div class="footer-copyright text-center py-3">
      <p id="year"></p>
    </div>
  </footer>
</template>

<script>
export default {
  mounted(){
    const d = new Date();
document.getElementById("year").innerHTML = '©' + ' ' + d.getFullYear()  + ' ' +'JordanDawsonInc';
  }
};
</script>

<style>
footer{
    background-color: purple;
    width: 100%;
    position:relative;
    bottom: 0px;
}
</style>